import React, { useState } from 'react';
import { sendContactEmail } from '../services/mailService';
import './ContactPage.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    email: '',
    telephone: '',
    typeProjet: '',
    surface: '',
    description: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await sendContactEmail(formData);
      setSubmitStatus('success');
      setFormData({
        nom: '',
        prenom: '',
        email: '',
        telephone: '',
        typeProjet: '',
        surface: '',
        description: ''
      });
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      {/* Header Section */}
      <section className="contact-header">
        <div className="container">
          <h1 className="page-title">Contactez-nous</h1>
          <p className="page-subtitle">
            Demandez votre devis gratuit et personnalisé pour tous vos projets de peinture et couverture
          </p>
        </div>
      </section>

      <div className="contact-content">
        <div className="container">
          <div className="contact-grid">
            {/* Formulaire de devis */}
            <div className="contact-form-section">
              <div className="form-container">
                <h2 className="form-title">📋 Demander un devis</h2>
                <p className="form-subtitle">
                  Remplissez ce formulaire et nous vous recontacterons dans les plus brefs délais
                </p>

                {submitStatus === 'success' && (
                  <div className="alert alert-success">
                    ✅ Votre demande de devis a été envoyée avec succès ! Nous vous recontacterons rapidement.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="alert alert-error">
                    ❌ Une erreur est survenue. Veuillez réessayer ou nous contacter directement.
                  </div>
                )}

                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="nom">Nom *</label>
                      <input
                        type="text"
                        id="nom"
                        name="nom"
                        value={formData.nom}
                        onChange={handleInputChange}
                        required
                        placeholder="Votre nom"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="prenom">Prénom *</label>
                      <input
                        type="text"
                        id="prenom"
                        name="prenom"
                        value={formData.prenom}
                        onChange={handleInputChange}
                        required
                        placeholder="Votre prénom"
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="email">Email *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        placeholder="exemple@gmail.com"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="telephone">Téléphone *</label>
                      <input
                        type="tel"
                        id="telephone"
                        name="telephone"
                        value={formData.telephone}
                        onChange={handleInputChange}
                        required
                        placeholder="06 01 02 03 04"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="typeProjet">Type de projet *</label>
                    <select
                      id="typeProjet"
                      name="typeProjet"
                      value={formData.typeProjet}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Sélectionnez un type de projet</option>
                      <option value="peinture-interieure">Peinture</option>
                      <option value="peinture-exterieure">Peinture extérieure</option>
                      <option value="couverture">Couverture/Toiture</option>
                      <option value="pose-sol">Pose de sol</option>
                      <option value="renovation-complete">Rénovation complète</option>
                      <option value="autre">Autre</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor="surface">Surface (m²)</label>
                    <input
                      type="number"
                      id="surface"
                      name="surface"
                      value={formData.surface}
                      onChange={handleInputChange}
                      placeholder="Ex: 50"
                      min="0"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="description">Description détaillée du projet *</label>
                    <textarea
                      id="description"
                      name="description"
                      value={formData.description}
                      onChange={handleInputChange}
                      rows="4"
                      required
                      placeholder="Décrivez votre projet en détail : type de travaux souhaités, pièces concernées, état actuel, contraintes particulières, adresse du chantier..."
                    />
                  </div>

                  <button 
                    type="submit" 
                    className="btn btn-primary btn-large btn-submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Envoi en cours...' : 'Envoyer ma demande'}
                  </button>
                </form>
              </div>
            </div>

            {/* Informations de contact */}
            <div className="contact-info-section">
              <div className="contact-info-card">
                <h2 className="info-title">📞 Nos coordonnées</h2>
                
                <div className="contact-methods">
                  <div className="contact-method">
                    <div className="method-icon">📞</div>
                    <div className="method-content">
                      <h3>Téléphone</h3>
                      <p><a href="tel:0766059863" className="link-plain">07 66 05 98 63</a></p>
                      <span className="method-note">Lun-Sam: 7h-19h</span>
                    </div>
                  </div>

                  <div className="contact-method">
                    <div className="method-icon">✉️</div>
                    <div className="method-content">
                      <h3>Email</h3>
                      <p><a href="mailto:senane.yassine44@gmail.com" className="link-plain">senane.yassine44@gmail.com</a></p>
                      <span className="method-note">Réponse sous 24h</span>
                    </div>
                  </div>

                  <div className="contact-method">
                    <div className="method-icon">📍</div>
                    <div className="method-content">
                      <h3>Localisation</h3>
                      <p>Couëron - Région nantaise</p>
                      <span className="method-note">Zone d'intervention: 80km</span>
                    </div>
                  </div>

                  <div className="contact-method">
                    <div className="method-icon">⏰</div>
                    <div className="method-content">
                      <h3>Horaires</h3>
                      <p>Lundi - Samedi: 7h00 - 19h00<br /></p>
                      <span className="method-note">Dimanche: Fermé</span>
                    </div>
                  </div>
                </div>

                <div className="emergency-contact">
                  <h3>🚨 Urgence ?</h3>
                  <p>Pour les interventions d'urgence (fuite, dégât des eaux), appelez-nous directement au :</p>
                  <a href="tel:0766059863" className="emergency-phone link-plain">07 66 05 98 63</a>
                </div>
              </div>

              <div className="why-choose-card">
                <h3>Pourquoi nous choisir ?</h3>
                <ul className="advantages-list">
                  <li>✅ Devis gratuit et sans engagement</li>
                  <li>✅ Savoir-faire local reconnu</li>
                  <li>✅ Travaux conformes et suivis</li>
                  <li>✅ Respect des délais</li>
                  <li>✅ Matériaux de qualité</li>
                  <li>✅ Prix transparents</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Prêt à concrétiser votre projet ?</h2>
            <p>Notre équipe d'experts est à votre disposition pour vous accompagner dans tous vos travaux.</p>
            <div className="cta-buttons">
              <a href="tel:0766059863" className="btn btn-primary btn-large link-plain">
                Appeler maintenant
              </a>
              <a href="mailto:senane.yassine44@gmail.com" className="btn btn-secondary btn-large link-plain">
                Envoyer un email
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
